import { render, staticRenderFns } from "./courseRecordForm.vue?vue&type=template&id=90e091a2&scoped=true"
import script from "./courseRecordForm.vue?vue&type=script&lang=js"
export * from "./courseRecordForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90e091a2",
  null
  
)

export default component.exports